import { render, staticRenderFns } from "./adminChannel.vue?vue&type=template&id=36b0b30d&scoped=true&"
import script from "./adminChannel.vue?vue&type=script&lang=js&"
export * from "./adminChannel.vue?vue&type=script&lang=js&"
import style0 from "./adminChannel.vue?vue&type=style&index=0&id=36b0b30d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0b30d",
  null
  
)

export default component.exports